import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslate } from '@im/react-localization';

export const PriorityChange = (props: {
  handleChangePriority: (e: any) => void;
  nchecked: boolean;
}) => {
  const translate = useTranslate();

  return (
    <>
      <Typography fontWeight={'bold'} mb={1} mt={3} variant="body2">
        {translate('Pricing.PriorityChange')}
      </Typography>
      <Grid
        alignItems="center"
        container
        spacing={1}
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontSize: '0.875rem',
        }}
      >
        <Grid item>{translate('Pricing.PriorityStandard')}</Grid>
        <Grid item>
          <Switch
            checked={props.nchecked}
            onChange={props.handleChangePriority}
          />
        </Grid>
        <Grid item>{translate('Pricing.PriorityUrgent')}</Grid>
      </Grid>
    </>
  );
};
